module.exports = __webpack_public_path__ + "img/bun-bottom.4bf3a632.svg";